import { render, staticRenderFns } from "./DeskEventSetDialog.vue?vue&type=template&id=3bbdddf1&scoped=true&"
import script from "./DeskEventSetDialog.vue?vue&type=script&lang=js&"
export * from "./DeskEventSetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbdddf1",
  null
  
)

export default component.exports